import React from 'react';

/**
 * Reused for both billing address (sent to Stripe on the customer record)
 * and service address (the property being treated -- stored on the order
 * only, since it's often different from billing: rentals, property
 * managers, someone paying for a parent's house).
 */
export default function AddressFields({ value, onChange, legend, required = true }) {
  function set(field, v) {
    onChange({ ...value, [field]: v });
  }

  return (
    <fieldset className="address-fields">
      {legend && <legend>{legend}</legend>}
      <label>Address line 1</label>
      <input value={value.line1 || ''} onChange={(e) => set('line1', e.target.value)} required={required} />
      <label>Address line 2 (optional)</label>
      <input value={value.line2 || ''} onChange={(e) => set('line2', e.target.value)} />
      <div className="form-row">
        <div>
          <label>City</label>
          <input value={value.city || ''} onChange={(e) => set('city', e.target.value)} required={required} />
        </div>
        <div>
          <label>State</label>
          <input value={value.state || ''} onChange={(e) => set('state', e.target.value.toUpperCase())} maxLength={2} placeholder="TX" required={required} />
        </div>
        <div>
          <label>ZIP</label>
          <input value={value.postalCode || ''} onChange={(e) => set('postalCode', e.target.value)} required={required} />
        </div>
      </div>
    </fieldset>
  );
}
